import {
  pick, omitBy, isNil, omit,
} from 'lodash'
import { isFeatureEnabled } from '@/store/modules/feature-toggles.module'
import { isColorLight } from '@/utils/color.util'

const DEFAULT_THEME_ATTRIBUTES = {
  textColour: '#313131',
  baseColour: '#ffffff',
  backgroundImage: null,
  visibility: 20,
}

const THEME_ATTRIBUTES = ['themeName', 'textColour', 'baseColour', 'visibility', 'backgroundImage', 'themeThumbnail', 'themeId', 'themeActive', 'colorPalette', 'logo', 'fontFamily']
const _state = {}

const nullifiedThemeEmptyField = (slide) => {
  const nullifiedSlide = {
    ...slide,
    textColour: slide.textColour === '' ? null : slide.textColour,
    baseColour: slide.baseColour === '' ? null : slide.baseColour,
    visibility: slide.visibility === -1 ? null : slide.visibility,
  }

  return omitBy(nullifiedSlide, isNil)
}

const _getters = {
  canViewThemeGallery: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-theme-gallery')
  },
  currentPresentationTheme: (_, __, rootState) => {
    const attribute = rootState.presentationAttributeModule.presentationAttribute
    const themeAttribute = pick(attribute, THEME_ATTRIBUTES)

    return {
      ...DEFAULT_THEME_ATTRIBUTES,
      ...themeAttribute,
    }
  },
  activeActivityWithTheme: (_, getters, __, rootGetters) => {
    const activeActivity = rootGetters?.activeActivity
    const presentationTheme = getters.currentPresentationTheme

    if (getters.canViewThemeGallery) {
      return {
        // We don't need these theme attributes since these attributes are rendered in another layer
        ...omit(presentationTheme, ['backgroundImage']),
        ...nullifiedThemeEmptyField(activeActivity),
      }
    }

    return activeActivity
  },
  isTextColourLight: (_, getters, __, rootGetters) => {
    const activeActivity = rootGetters?.activeActivity
    const { activeActivityWithTheme } = getters
    if (getters.canViewThemeGallery) {
      return isColorLight(activeActivityWithTheme.textColour)
    }

    return activeActivity.textColour === '#ffffff'
  },
  activeActivityBaseColour: (_, __, ___, rootGetters) => {
    const { baseColour } = nullifiedThemeEmptyField(rootGetters?.activeActivity)

    return baseColour
  },
  contrastBackgroundColour: (_, getters) => {
    const { textColour, baseColour } = getters?.activeActivityWithTheme
    if (getters.canViewThemeGallery) {
      // To make sure it always contrast with the text colour
      return isColorLight(textColour)
        ? DEFAULT_THEME_ATTRIBUTES.textColour
        : DEFAULT_THEME_ATTRIBUTES.baseColour
    }
    return baseColour
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
}
